/* Diwali product page: sliding gallery with thumbnail strip, option cards,
   quantity with the store's minimum order, buy box, hearts and info tabs.
   Framework free. Hands the cart off to the Maximize drawer the same way
   ganesh-product.js does. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORAGE_KEY = 'dwp:saved-products';

  /* ------------------------------------------------------------ cart drawer */

  /* The theme's own xMiniCart.reLoad() never refreshes #CartDrawer's markup, so
     ask for the rendered sections in the add request and swap them in. */
  function cartSectionsToRender() {
    var sections = [{ id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
    var drawer = document.querySelector('#CartDrawer');
    if (drawer && drawer.dataset.sectionId) {
      sections.push({ id: drawer.dataset.sectionId, selector: '#CartDrawer' });
    }
    return sections;
  }

  function applyCartSections(payload) {
    if (!payload || !payload.sections) return false;
    var swappedDrawer = false;

    cartSectionsToRender().forEach(function (section) {
      var target = document.querySelector(section.selector);
      var html = payload.sections[section.id];
      if (!target || !html) return;

      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!fresh) return;

      target.innerHTML = fresh.innerHTML;
      if (section.selector === '#CartDrawer') swappedDrawer = true;
    });

    return swappedDrawer;
  }

  function refreshThemeCart(payload) {
    var drawerIsFresh = applyCartSections(payload);

    try {
      if (window.Alpine && typeof Alpine.store === 'function') {
        var miniCart = Alpine.store('xMiniCart');
        var cartHelper = Alpine.store('xCartHelper');
        if (cartHelper && typeof cartHelper.updateCurrentCountItem === 'function') {
          cartHelper.updateCurrentCountItem();
        }
        if (miniCart) {
          if (drawerIsFresh) {
            if (typeof miniCart.handleOpen === 'function') miniCart.handleOpen();
          } else if (typeof miniCart.reLoad === 'function') {
            miniCart.reLoad(true);
          }
        }
      }
    } catch (error) {
      console.warn('[diwali] cart drawer refresh skipped', error);
    }

    var eventName = (window.CART_EVENT && window.CART_EVENT.cartUpdate) || 'maximize:cart:updated';
    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: { isItemCountChanged: true }
    }));
  }

  /* ---------------------------------------------------------------- gallery */

  function initGallery(section) {
    var gallery = section.querySelector('[data-dwp-gallery]');
    if (!gallery) return null;

    var stage = gallery.querySelector('[data-dwp-stage]');
    var track = gallery.querySelector('[data-dwp-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-dwp-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-dwp-thumb]'));
    var strip = gallery.querySelector('[data-dwp-thumbs]');
    var thumbPrev = gallery.querySelector('[data-dwp-thumb-prev]');
    var thumbNext = gallery.querySelector('[data-dwp-thumb-next]');
    if (!stage || !track || !slides.length) return null;

    var current = 0;

    function isVertical() {
      return strip && strip.scrollHeight > strip.clientHeight + 2 && strip.scrollWidth <= strip.clientWidth + 2;
    }

    function centerThumb(thumb) {
      if (!strip || !thumb) return;
      if (isVertical()) {
        strip.scrollTo({ top: thumb.offsetTop - strip.clientHeight / 2 + thumb.offsetHeight / 2, behavior: 'smooth' });
      } else {
        strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.offsetWidth / 2, behavior: 'smooth' });
      }
    }

    function updateThumbArrows() {
      if (!strip || !thumbPrev || !thumbNext) return;
      var horizontalOverflow = strip.scrollWidth > strip.clientWidth + 2;
      var atStart = strip.scrollLeft <= 2;
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      thumbPrev.hidden = !horizontalOverflow || atStart;
      thumbNext.hidden = !horizontalOverflow || atEnd;
    }

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          centerThumb(thumb);
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { show(index); });
    });

    var prev = gallery.querySelector('[data-dwp-prev]');
    var next = gallery.querySelector('[data-dwp-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    if (strip) {
      strip.addEventListener('scroll', updateThumbArrows, { passive: true });
      window.addEventListener('resize', updateThumbArrows);
      if (thumbPrev) thumbPrev.addEventListener('click', function () {
        strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' });
      });
      if (thumbNext) thumbNext.addEventListener('click', function () {
        strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' });
      });
      updateThumbArrows();
      window.setTimeout(updateThumbArrows, 400);
    }

    /* swipe the big image */
    var startX = 0;
    var startY = 0;
    var tracking = false;

    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      tracking = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        show(current + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    /* mouse drag on desktop */
    var dragging = false;
    var dragStart = 0;
    stage.addEventListener('mousedown', function (event) {
      if (event.target.closest('button')) return;
      dragging = true;
      dragStart = event.clientX;
    });
    window.addEventListener('mouseup', function (event) {
      if (!dragging) return;
      dragging = false;
      var dx = event.clientX - dragStart;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
    });

    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
    });

    show(0);
    return { show: show };
  }

  /* ----------------------------------------------------------- option cards */

  function initVariants(section, gallery) {
    var form = section.querySelector('[data-dwp-form]');
    var dataEl = section.querySelector('[data-dwp-variants]');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.warn('[diwali] could not read variant data', error);
      return;
    }
    if (!variants || variants.length < 2) return;

    var config = {};
    try {
      var configEl = section.querySelector('[data-dwp-config]');
      if (configEl) config = JSON.parse(configEl.textContent) || {};
    } catch (error) { config = {}; }

    var cards = Array.prototype.slice.call(form.querySelectorAll('[data-dwp-value]'));
    if (!cards.length) return;

    var idField = form.querySelector('[data-dwp-variant-id]');
    var priceEl = section.querySelector('[data-dwp-price]');
    var compareEl = section.querySelector('[data-dwp-compare]');
    var discountEl = section.querySelector('[data-dwp-discount]');
    var badgeEl = section.querySelector('[data-dwp-badge]');
    var atc = form.querySelector('[data-dwp-atc]');
    var atcLabel = form.querySelector('[data-dwp-atc-label]');
    var buyNow = form.querySelector('[data-dwp-buy-now]');

    var optionCount = variants[0].options.length;

    var formatter = null;
    try {
      formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: config.currency || 'INR',
        maximumFractionDigits: 0
      });
    } catch (error) { formatter = null; }

    function money(cents) {
      var amount = cents / 100;
      if (formatter && Math.round(amount) === amount) return formatter.format(amount);
      if (formatter) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: config.currency || 'INR' }).format(amount);
        } catch (error) { /* fall through */ }
      }
      return String(amount);
    }

    function selected() {
      var chosen = [];
      cards.forEach(function (card) {
        if (card.classList.contains('is-selected')) {
          chosen[parseInt(card.dataset.position, 10) - 1] = card.dataset.value;
        }
      });
      return chosen;
    }

    function exact(options) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < optionCount; j++) {
          if (variants[i].options[j] !== options[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    /* best variant that has this value, keeping as many other picks as possible */
    function closest(options, position, value) {
      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[position - 1] !== value) return;
        var score = 0;
        for (var j = 0; j < optionCount; j++) {
          if (j !== position - 1 && v.options[j] === options[j]) score += 1;
        }
        if (v.available) score += 0.5;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }

    function priceFor(position, value, options) {
      var trial = options.slice();
      trial[position - 1] = value;
      var found = exact(trial) || closest(options, position, value);
      return found ? found.priceCents : null;
    }

    function refreshCardPrices(options) {
      cards.forEach(function (card) {
        var position = parseInt(card.dataset.position, 10);
        var target = card.querySelector('[data-dwp-card-price]');
        var available = true;
        var trial = options.slice();
        trial[position - 1] = card.dataset.value;
        var found = exact(trial) || closest(options, position, card.dataset.value);
        available = !!found && found.available;
        card.classList.toggle('is-unavailable', !available);
        if (!target) return;

        var cents = priceFor(position, card.dataset.value, options);
        if (cents === null) { target.textContent = ''; return; }

        if (position === 1) {
          target.textContent = money(cents);
          return;
        }

        var firstCard = form.querySelector('[data-dwp-value][data-position="' + position + '"]');
        var baseCents = firstCard ? priceFor(position, firstCard.dataset.value, options) : null;
        if (baseCents === null) { target.textContent = ''; return; }
        var delta = cents - baseCents;
        if (delta > 0) target.textContent = '+' + money(delta);
        else if (delta < 0) target.textContent = '-' + money(-delta);
        else target.textContent = '';
      });
    }

    function setSelection(variant) {
      cards.forEach(function (card) {
        var position = parseInt(card.dataset.position, 10);
        var isOn = variant.options[position - 1] === card.dataset.value;
        card.classList.toggle('is-selected', isOn);
        card.setAttribute('aria-checked', isOn ? 'true' : 'false');
      });
    }

    function apply(variant) {
      var options = selected();
      refreshCardPrices(options);

      if (!variant) {
        if (atc) atc.disabled = true;
        if (buyNow) buyNow.disabled = true;
        if (atcLabel && atc) atcLabel.textContent = atc.dataset.soldOutText || 'Sold out';
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;

      if (compareEl) {
        compareEl.textContent = variant.compare;
        compareEl.hidden = !variant.hasCompare;
      }
      if (discountEl) {
        discountEl.textContent = variant.discount + '% OFF';
        discountEl.hidden = variant.discount <= 0;
      }
      if (badgeEl) {
        badgeEl.textContent = variant.discount + '% OFF';
        badgeEl.hidden = variant.discount <= 0;
      }

      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) {
          atcLabel.textContent = variant.available
            ? (atc.dataset.defaultText || atcLabel.textContent)
            : (atc.dataset.soldOutText || 'Sold out');
        }
      }
      if (buyNow) buyNow.disabled = !variant.available;

      if (gallery && variant.image !== null && variant.image !== undefined) {
        gallery.show(variant.image);
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) { /* older browser, the form still carries the right id */ }
    }

    if (atc && atcLabel) atc.dataset.defaultText = atcLabel.textContent.trim();

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var position = parseInt(card.dataset.position, 10);
        var options = selected();
        var variant = closest(options, position, card.dataset.value);
        if (!variant) return;
        setSelection(variant);
        apply(variant);
      });
    });

    var initial = exact(selected());
    apply(initial);
  }

  /* --------------------------------------------------------------- quantity */

  function initQuantity(section) {
    var input = section.querySelector('[data-dwp-qty-input]');
    if (!input) return;
    var min = parseInt(input.dataset.min, 10) || 1;

    section.querySelectorAll('[data-dwp-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.dwpQty, 10) || 0;
        var value = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, value);
      });
    });

    input.addEventListener('change', function () {
      var value = parseInt(input.value, 10);
      if (!value || value < min) input.value = min;
    });
  }

  /* ---------------------------------------------------------------- buy box */

  function collectLineItemProperties(form) {
    var properties = {};
    Array.prototype.slice.call(form.querySelectorAll('[name^="properties["]')).forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      var value = (input.value || '').trim();
      if (value) properties[match[1]] = value;
    });
    return properties;
  }

  var burstOrigin = null;

  function addToCart(form) {
    var idField = form.querySelector('[data-dwp-variant-id]');
    var qtyField = form.querySelector('[name="quantity"]');
    var properties = collectLineItemProperties(form);
    var minimum = qtyField ? (parseInt(qtyField.dataset.min, 10) || 1) : 1;
    var item = {
      id: idField.value,
      quantity: Math.max(minimum, parseInt(qtyField && qtyField.value, 10) || minimum)
    };
    if (Object.keys(properties).length) item.properties = properties;

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: cartSectionsToRender().map(function (section) { return section.id; })
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  function initBuyBox(section) {
    var form = section.querySelector('[data-dwp-form]');
    if (!form) return;

    var note = form.querySelector('[data-dwp-note]');
    var atc = form.querySelector('[data-dwp-atc]');
    var atcLabel = form.querySelector('[data-dwp-atc-label]');
    var buyNow = form.querySelector('[data-dwp-buy-now]');

    function say(message, kind) {
      if (!note) return;
      note.textContent = message;
      note.className = 'dwp-pdp__note' + (kind ? ' dwp-pdp__note--' + kind : '');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;

      var original = atcLabel ? atcLabel.textContent : '';
      if (window.DiwaliCartBurst) window.DiwaliCartBurst.fire(burstOrigin || atc);
      burstOrigin = null;
      atc.classList.add('is-loading');
      if (atcLabel) atcLabel.textContent = atc.dataset.addingText || 'Adding...';
      say('');

      addToCart(form)
        .then(function (payload) {
          say(atc.dataset.addedText || 'Added to cart', 'success');
          refreshThemeCart(payload);
        })
        .catch(function (error) { say(error.message, 'error'); })
        .finally(function () {
          atc.classList.remove('is-loading');
          if (atcLabel) atcLabel.textContent = original;
        });
    });

    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled || buyNow.classList.contains('is-loading')) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        buyNow.classList.add('is-loading');
        say('');
        var tapped = Date.now();
        if (window.DiwaliCartBurst) window.DiwaliCartBurst.fire(buyNow);

        addToCart(form)
          .then(function () {
            /* let the fireworks play before the page moves on to checkout */
            var wait = reducedMotion() ? 0 : Math.max(0, 1100 - (Date.now() - tapped));
            window.setTimeout(function () { window.location.href = ROOT + 'checkout'; }, wait);
          })
          .catch(function (error) {
            say(error.message, 'error');
            buyNow.classList.remove('is-loading');
          });
      });
    }
  }

  /* ----------------------------------------------------------------- hearts */

  function initHearts(section) {
    var buttons = section.querySelectorAll('[data-dwp-wish]');
    if (!buttons.length) return;

    function read() {
      try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]'); } catch (error) { return []; }
    }

    buttons.forEach(function (button) {
      var id = button.dataset.dwpWish;
      button.setAttribute('aria-pressed', read().indexOf(id) > -1 ? 'true' : 'false');

      button.addEventListener('click', function () {
        var list = read();
        var index = list.indexOf(id);
        if (index > -1) {
          list.splice(index, 1);
          button.setAttribute('aria-pressed', 'false');
        } else {
          list.push(id);
          button.setAttribute('aria-pressed', 'true');
        }
        try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (error) { /* private browsing */ }
      });
    });
  }

  /* ------------------------------------------------- bulk price calculator */

  function parseMoney(text) {
    var match = String(text).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return match ? parseFloat(match[1]) : NaN;
  }

  function readTiers(section) {
    var table = section.querySelector('[data-dwp-panel="bulk"] table');
    var tiers = [];
    if (!table) return tiers;
    Array.prototype.slice.call(table.querySelectorAll('tbody tr')).forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (cells.length < 2) return;
      var range = cells[0].textContent.replace(/,/g, '');
      var nums = range.match(/\d+/g);
      var price = parseMoney(cells[1].textContent);
      if (!nums || isNaN(price)) return;
      var min = parseInt(nums[0], 10);
      var max = /\+/.test(range) ? Infinity : (nums.length > 1 ? parseInt(nums[1], 10) : min);
      tiers.push({ min: min, max: max, price: price });
    });
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }

  function initCalc(section) {
    var box = section.querySelector('[data-dwp-calc]');
    var input = section.querySelector('[data-dwp-qty-input]');
    var priceEl = section.querySelector('[data-dwp-price]');
    if (!box || !input || !priceEl) return;
    var tiers = readTiers(section);
    if (!tiers.length) return;
    var min = parseInt(input.dataset.min, 10) || 1;
    var qtyEl = box.querySelector('[data-dwp-calc-qty]');
    var rateEl = box.querySelector('[data-dwp-calc-rate]');
    var totalEl = box.querySelector('[data-dwp-calc-total]');
    var saveEl = box.querySelector('[data-dwp-calc-save]');
    var nextEl = box.querySelector('[data-dwp-calc-next]');

    function tierFor(qty) {
      var found = tiers[0];
      tiers.forEach(function (tier) { if (qty >= tier.min) found = tier; });
      return found;
    }

    function render() {
      var qty = Math.max(min, parseInt(input.value, 10) || min);
      var text = priceEl.textContent;
      var base = parseMoney(text);
      var prefix = (text.match(/^[^\d]*/) || [''])[0];
      function fmt(value) { return prefix + Math.round(value).toLocaleString('en-IN'); }
      var tier = tierFor(qty);
      var rate = tier.price;
      var last = tiers[tiers.length - 1];

      qtyEl.textContent = qty;
      rateEl.textContent = fmt(rate);
      totalEl.textContent = fmt(rate * qty);

      var saved = (base - rate) * qty;
      saveEl.textContent = saved > 0.5 ? 'You save ' + fmt(saved) + ' (' + Math.round((base - rate) / base * 100) + '% off)' : '';

      nextEl.textContent = '';
      if (qty > last.max && isFinite(last.max)) {
        nextEl.textContent = 'Above ' + last.max + ' pcs? Ask us for a custom quote.';
      } else {
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].min > qty && tiers[i].price < rate) {
            nextEl.textContent = 'Add ' + (tiers[i].min - qty) + (tiers[i].min - qty === 1 ? ' more pc' : ' more pcs') + ' to get ' + fmt(tiers[i].price) + ' each';
            break;
          }
        }
      }
      box.hidden = false;
    }

    function later() { window.setTimeout(render, 0); }
    input.addEventListener('input', render);
    input.addEventListener('change', render);
    section.querySelectorAll('[data-dwp-qty]').forEach(function (button) { button.addEventListener('click', later); });
    if (window.MutationObserver) new MutationObserver(render).observe(priceEl, { childList: true, characterData: true, subtree: true });
    render();
  }

  /* ------------------------------------------------------ gifting and quote */

  function initGifting(section) {
    var date = section.querySelector('[data-dwp-gift-date]');
    if (date) {
      var now = new Date();
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      date.min = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    }
  }

  function initQuote(section) {
    var link = section.querySelector('[data-dwp-quote]');
    var form = section.querySelector('[data-dwp-form]');
    if (!link || !form) return;
    var base = link.getAttribute('href');

    link.addEventListener('click', function () {
      var qtyField = form.querySelector('[name="quantity"]');
      var lines = ['Hi, I would like a bulk quote.', 'Product: ' + (link.dataset.product || document.title)];
      if (qtyField && qtyField.value) lines.push('Quantity: ' + qtyField.value + ' pcs');
      var properties = collectLineItemProperties(form);
      Object.keys(properties).forEach(function (key) { lines.push(key + ': ' + properties[key]); });
      lines.push(window.location.origin + window.location.pathname);
      link.setAttribute('href', base + '?text=' + encodeURIComponent(lines.join('\n')));
    });
  }

  /* ----------------------------------------------------------- delivery date */

  function initDelivery(section) {
    var box = section.querySelector('[data-dwp-delivery]');
    if (!box) return;
    var form = box.querySelector('[data-dwp-del-form]');
    var input = box.querySelector('[data-dwp-del-input]');
    var result = box.querySelector('[data-dwp-del-result]');
    var cfg = {
      process: parseInt(box.dataset.process, 10) || 0,
      min: parseInt(box.dataset.min, 10) || 3,
      max: parseInt(box.dataset.max, 10) || 6,
      far: parseInt(box.dataset.far, 10) || 0
    };
    var diwali = Date.parse((box.dataset.diwali || '') + 'T00:00:00+05:30');
    var KEY = 'dwp-pincode';

    function addDays(date, count) {
      var d = new Date(date.getTime());
      while (count > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) count -= 1;
      }
      return d;
    }
    function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }

    function show(html, cls) {
      result.className = 'dwp-del__result' + (cls ? ' ' + cls : '');
      result.innerHTML = html;
    }

    function check(pin) {
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        show('Please enter a valid 6 digit pincode.', 'dwp-del__bad');
        return;
      }
      var extra = /^(7|8|18|19)/.test(pin) ? cfg.far : 0;
      var start = addDays(new Date(), cfg.process);
      var from = addDays(start, cfg.min + extra);
      var to = addDays(start, cfg.max + extra);
      var html = 'Estimated delivery to <strong>' + pin + '</strong>: <strong>' + fmt(from) + '</strong> to <strong>' + fmt(to) + '</strong>';
      if (!isNaN(diwali)) {
        html += to.getTime() < diwali
          ? '<span class="dwp-del__ok">Arrives before Diwali</span>'
          : '<span class="dwp-del__late">May reach you after Diwali. Message us on WhatsApp for faster options.</span>';
      }
      show(html);
      try { window.localStorage.setItem(KEY, pin); } catch (error) { /* private browsing */ }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      check(input.value.trim());
    });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });

    try {
      var saved = window.localStorage.getItem(KEY);
      if (saved && /^[1-9][0-9]{5}$/.test(saved)) { input.value = saved; check(saved); }
    } catch (error) { /* private browsing */ }
  }

  /* ------------------------------------------------- sticky add to cart bar */

  function initSticky(section) {
    var bar = section.querySelector('[data-dwp-sticky]');
    var actions = section.querySelector('.dwp-pdp__actions');
    var form = section.querySelector('[data-dwp-form]');
    var atc = section.querySelector('[data-dwp-atc]');
    var priceEl = section.querySelector('[data-dwp-price]');
    if (!bar || !actions || !form || !atc) return;
    var button = bar.querySelector('[data-dwp-sticky-add]');
    var barPrice = bar.querySelector('[data-dwp-sticky-price]');
    var atcLabel = section.querySelector('[data-dwp-atc-label]');

    function syncButton() {
      button.disabled = atc.disabled;
      if (atcLabel) button.textContent = atcLabel.textContent;
    }

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      button.tabIndex = on ? 0 : -1;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }).observe(actions);
    }

    if (window.MutationObserver) {
      if (priceEl && barPrice) new MutationObserver(function () { barPrice.textContent = priceEl.textContent; }).observe(priceEl, { childList: true, characterData: true, subtree: true });
      if (atcLabel) new MutationObserver(syncButton).observe(atcLabel, { childList: true, characterData: true, subtree: true });
      new MutationObserver(syncButton).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    }

    button.addEventListener('click', function () {
      if (atc.disabled) return;
      burstOrigin = button;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
      else atc.click();
    });
    syncButton();
  }

  /* ---------------------------------------------------------- read more */

  function initReadMore(section) {
    var summary = section.querySelector('[data-dwp-summary]');
    if (!summary) return;
    var button = summary.querySelector('[data-dwp-more]');
    var shortText = summary.querySelector('[data-dwp-summary-short]');
    var fullText = summary.querySelector('[data-dwp-summary-full]');
    if (!button || !shortText || !fullText) return;
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') !== 'true';
      shortText.hidden = open;
      fullText.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.textContent = open ? button.dataset.less : button.dataset.more;
    });
  }

  /* ------------------------------------------------------------------- tabs */

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTabs(section) {
    var wrap = section.querySelector('[data-dwp-tabs]');
    if (!wrap) return;

    var nav = wrap.querySelector('.dwp-tabs__nav');
    var bar = wrap.querySelector('[data-dwp-tab-bar]');
    var body = wrap.querySelector('[data-dwp-tabs-body]');
    var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[data-dwp-tab]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-dwp-panel]'));
    var token = 0;

    function activeButton() {
      return buttons.filter(function (button) { return button.classList.contains('is-active'); })[0];
    }

    function moveBar() {
      var button = activeButton();
      if (!bar || !button) return;
      bar.style.width = button.offsetWidth + 'px';
      bar.style.transform = 'translateX(' + button.offsetLeft + 'px)';
    }

    function centreTab(button) {
      if (!nav || nav.scrollWidth <= nav.clientWidth) return;
      var left = button.offsetLeft - (nav.clientWidth - button.offsetWidth) / 2;
      if (typeof nav.scrollTo === 'function') nav.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
      else nav.scrollLeft = left;
    }

    function panelFor(name) {
      return panels.filter(function (panel) { return panel.dataset.dwpPanel === name; })[0];
    }

    function activate(name) {
      var current = activeButton();
      if (current && current.dataset.dwpTab === name) return;

      buttons.forEach(function (button) {
        var on = button.dataset.dwpTab === name;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) centreTab(button);
      });
      moveBar();

      var next = panelFor(name);
      var prev = panels.filter(function (panel) { return !panel.hidden; })[0];
      var mine = ++token;

      if (!next) return;
      if (!body || !prev || prev === next || reducedMotion()) {
        panels.forEach(function (panel) { panel.hidden = panel !== next; });
        return;
      }

      /* fade the old panel out, swap, then fade the new one in while the box
         glides to its new height */
      var startHeight = body.offsetHeight;
      body.style.height = startHeight + 'px';
      body.classList.add('is-animating');
      prev.classList.add('is-leaving');

      window.setTimeout(function () {
        if (mine !== token) return;
        prev.hidden = true;
        prev.classList.remove('is-leaving');
        next.classList.add('is-entering');
        next.hidden = false;

        body.style.height = 'auto';
        var endHeight = body.offsetHeight;
        body.style.height = startHeight + 'px';
        void body.offsetHeight;
        body.style.height = endHeight + 'px';
        next.classList.remove('is-entering');

        window.setTimeout(function () {
          if (mine !== token) return;
          body.style.height = '';
          body.classList.remove('is-animating');
        }, 400);
      }, 190);
    }

    wrap.classList.add('dwp-tabs--js');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () { activate(button.dataset.dwpTab); });
    });
    moveBar();
    window.addEventListener('resize', moveBar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveBar);
    window.addEventListener('load', moveBar);
  }

  /* ----------------------------------------------------- assurance marquee */

  function initTrust(section) {
    var wrap = section.querySelector('[data-dwp-trust]');
    if (!wrap || !wrap.classList.contains('dwp-pdp__trust--marquee')) return;
    if (reducedMotion()) return;
    var speed = parseFloat(wrap.dataset.speed) || 45;
    var timer = 0;
    var rows = Array.prototype.slice.call(wrap.querySelectorAll('[data-dwp-trust-row]'));

    function build() { rows.forEach(buildRow); }

    function buildRow(row) {
      var track = row.querySelector('[data-dwp-trust-track]');
      var group = row.querySelector('[data-dwp-trust-group]');
      if (!track || !group) return;
      Array.prototype.slice.call(track.querySelectorAll('[data-dwp-clone]')).forEach(function (node) {
        node.parentNode.removeChild(node);
      });
      var width = group.getBoundingClientRect().width;
      if (!width) return;
      var copies = Math.max(2, Math.ceil(wrap.clientWidth / width) + 1);
      for (var i = 1; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.removeAttribute('data-dwp-trust-group');
        clone.setAttribute('data-dwp-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        Array.prototype.slice.call(clone.querySelectorAll('*')).forEach(function (node) {
          node.removeAttribute('data-shopify-editor-block');
        });
        track.appendChild(clone);
      }
      row.style.setProperty('--dwp-copies', copies);
      row.style.setProperty('--dwp-marquee-duration', (width / speed).toFixed(2) + 's');
      row.classList.add('is-ready');
    }

    build();
    window.addEventListener('load', build);
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(build, 200);
    });
  }

  /* ------------------------------------------------------ related products */

  function initRelated(section) {
    var wrap = section.querySelector('[data-dwp-related]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-dwp-rel-track]');
    var prev = wrap.querySelector('[data-dwp-rel-prev]');
    var next = wrap.querySelector('[data-dwp-rel-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.dwp-rel__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card.offsetWidth + gap) * Math.max(1, Math.round(track.clientWidth / (card.offsetWidth + gap)) - 1 || 1);
    }

    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var fits = track.scrollWidth <= track.clientWidth + 2;
      if (prev) prev.style.visibility = fits ? 'hidden' : '';
      if (next) next.style.visibility = fits ? 'hidden' : '';
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }

  /* ------------------------------------------------------------------- boot */

  function init(scope) {
    var sections = Array.prototype.slice.call((scope || document).querySelectorAll('[data-dwp-section]'));
    if (scope && scope.matches && scope.matches('[data-dwp-section]')) sections.push(scope);

    sections.forEach(function (section) {
      if (section.dataset.dwpReady === 'true') return;
      section.dataset.dwpReady = 'true';

      var gallery = initGallery(section);
      initVariants(section, gallery);
      initQuantity(section);
      initBuyBox(section);
      initHearts(section);
      initTabs(section);
      initReadMore(section);
      initCalc(section);
      initGifting(section);
      initQuote(section);
      initDelivery(section);
      initSticky(section);
      initTrust(section);
      initRelated(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
